import React from 'react';
import I18n from '@utils/i18n';
import { Text } from '@ui';
function QbRetiredBanner({ retiredOn }) {
    return (React.createElement("div", { className: "qmb-alert--info pc-edit__qb-banner mb-3" },
        React.createElement("i", { className: "fa-regular fa-ban alert__visual" }),
        React.createElement("div", null,
            React.createElement(Text, { variant: "x-small", as: "strong" }, I18n.t('proposed_corrections.edit.qb_retired_banner_title', { date: retiredOn })),
            React.createElement(Text, { variant: "body", as: "p" }, I18n.t('proposed_corrections.edit.qb_retired_banner_description')))));
}
export default QbRetiredBanner;
